// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Gf4","question":"styles_question__27wIM","description":"styles_description__-kH_K"};